import { z } from 'zod';
/** ISO 4217 currency code: exactly three uppercase letters, e.g. USD, LBP, EUR. */
export const currencyCodeSchema = z
    .string()
    .regex(/^[A-Z]{3}$/, 'Currency code must be 3 uppercase letters (ISO 4217)');
/**
 * The currencies the screens offer for now (Phase 3: USD and LBP). The API and the database stay
 * generic: each family has its own list of enabled currencies.
 */
export const UI_CURRENCIES = ['USD', 'LBP'];
/** Enabled for every family next to its base currency (the database seeds the same list). */
export const DEFAULT_EXTRA_CURRENCIES = ['LBP'];
/** Decimals an amount may have, when not the default 4 (NUMERIC(20,4)). */
const AMOUNT_SCALES = {
    // The Lebanese pound has no usable fractional unit: LBP amounts are whole numbers.
    LBP: 0,
};
export const DEFAULT_AMOUNT_SCALE = 4;
/**
 * How many decimals an amount in this currency may have. The `currencies` table in PostgreSQL
 * holds the same numbers, and a database test checks they match.
 */
export function amountScale(currency) {
    return AMOUNT_SCALES[currency] ?? DEFAULT_AMOUNT_SCALE;
}
/** Every currency with a non-default scale, for the database consistency test. */
export const CURRENCY_AMOUNT_SCALES = AMOUNT_SCALES;
/**
 * Display order: the base currency first, then the screens' currencies (USD, LBP), then the rest
 * alphabetically. Duplicates are dropped.
 */
export function sortCurrencies(codes, baseCurrency) {
    const rank = (code) => {
        if (code === baseCurrency)
            return 0;
        const ui = UI_CURRENCIES.indexOf(code);
        return ui >= 0 ? 1 + ui : 1 + UI_CURRENCIES.length;
    };
    return [...new Set(codes)].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}
//# sourceMappingURL=currency.js.map